export const ACTION_TYPE_ADD = "ADD";

export const ACTION_TYPE_ADD_CLIENT = "ADD_CLIENT";
export const ACTION_TYPE_UPDATE_CLIENT = "UPDATE_CLIENT";

export const ACTION_TYPE_ADD_BILLING = "ADD_BILLING"
export const ACTION_TYPE_UPDATE_BILLING = "UPDATE_BILLING";